import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StatiManutenzioneFormComponent } from './dialogs/form/form.component';
import { StatiManutenzioneRoutingModule } from './stati-manutenzione-routing.module';
import { StatiManutenzioneComponent } from './stati-manutenzione.component';
import { CustomMaterialModule } from '../../material-module/material.module';
import { ResourcefulIndexModule } from '../../shared/resourceful-index/resourceful-index.module';
import { CustomFormControlsModule } from 'src/app/shared/custom-form-controls/custom-form-controls.module';

@NgModule({
  declarations: [StatiManutenzioneComponent, StatiManutenzioneFormComponent],
  imports: [
    CommonModule,
    StatiManutenzioneRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CustomMaterialModule,
    CustomFormControlsModule,
    ResourcefulIndexModule,
  ]
})
export class StatiManutenzioneModule { }
